module.exports = __webpack_public_path__ + "static/media/05.090aa7e8.jpg";